import { deepMerge } from '../../utils/deepMerge.js';
// Dynamically import the JSON file for the specified language
export async function loadLocale(lng, customLanguageResource) {
    let languageResource;
    try {
        const languageResourceModule = await import(`../../i18n/${lng}.json`);
        languageResource = languageResourceModule.default;
    }
    catch {
        languageResource = {};
    }
    return mergeWithLanguageResources(languageResource, customLanguageResource);
}
export function mergeWithLanguageResources(languageResource, customLanguageResource) {
    return customLanguageResource
        ? deepMerge(languageResource, customLanguageResource)
        : languageResource;
}
//# sourceMappingURL=i18n.js.map